<lxm-dialog [dialogRef]="dialogRef" [formGroup]="form">
  <span header-title>
    {{ 'cards.reports.sales_report.expand_title' | translate }}
  </span>

  <div body>
    <scope translationsPath="cards.reports.sales_report_search">
    <form-field
      dialog
      label="period"
      for="from"
    >
      <div any class="date-range">
            <lxm-datepicker
              for="from"
              class="f-1"
              placeholder="cards.reports.sales_report_search.date_from"
              [min]="fromMin"
              [max]="fromMax"
              [disabled]="isSubmitting || fromLocked"
            ></lxm-datepicker>
            <div class="date-range__separator">-</div>
            <lxm-datepicker
              for="to"
              class="f-1"
              placeholder="cards.reports.sales_report_search.date_to"
              [min]="toMin"
              [max]="toMax"
              [disabled]="isSubmitting || toLocked"
            ></lxm-datepicker>
          </div>
    </form-field>

    <form-field
      dialog
      label="show_on_chart"
      for="fileType"
    >
      <div any class="file-type-options">
        <lxm-button
          type="transparent"
          class="file-type-option"
          *ngFor="let option of fileTypeOptions"
          [class.file-type-option--active]="hasFileType(option.id)"
          [icon]="option.icon"
          [label]="option.name"
          [disabled]="isSubmitting || isFileTypeLocked(option.id)"
          padding="0 10px 0 8px"
          [attr.aria-pressed]="hasFileType(option.id)"
          (click)="toggleFileType(option.id)"
        ></lxm-button>
      </div>
    </form-field>

    <form-field
      dialog
      label="stores"
      for="locations"
    >
      <lxm-select
        select
        for="locations"
        [options]="locationOptions"
        labelField="name"
        value="id"
        [multiple]="true"
        [searchable]="true"
        [clearable]="true"
        [disabled]="isSubmitting || allLocationsSelected"
        placeholder="cards.reports.sales_report_search.stores_placeholder"
      >
      </lxm-select>
    </form-field>
    <small
      class="expand-error"
      *ngFor="let error of validationErrors"
    >
      {{ error.value | translate: error.args }}
    </small>
    </scope>
  </div>

  <div footer>
    <lxm-button
      type="primary"
      buttonType="submit"
      [loading]="isSubmitting"
      label="cards.reports.sales_report.expand_submit"
      (click)="submit()"
    ></lxm-button>
    <lxm-button
      type="tertiary"
      buttonType="button"
      label="action.close"
      [disabled]="isSubmitting"
      (click)="close()"
    ></lxm-button>
  </div>
</lxm-dialog>
